<app-home [titre]="title"
          [menu]="menu"
          [anonymous]="anonymous"
          [miniSidenav]="true"
          [darkTheme]="true"
          class="mat-typography"
></app-home>
<span *ngIf="showLoader" class="loading"></span>
